import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchFeatured } from "@/lib/featuredPro";
import { FeaturedSpotlight } from "@/components/featured/FeaturedSpotlight";

const PLACEMENT = "HOME_FEATURED_PROFESSIONALS";

// Public homepage Featured Professionals carousel. Renders nothing without live placements.
export function FeaturedProsCarousel() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetchFeatured({ placement: PLACEMENT }).then(setItems).catch(() => setItems([])); }, []);
  if (!items.length) return null;
  return (
    <FeaturedSpotlight tid="featured-pros-section" placement={PLACEMENT} items={items}
      inner="mx-auto max-w-7xl px-4 py-9 sm:px-6 sm:py-10"
      subtitle="Meet real estate professionals featured across the PropertyConnect network."
      headerExtra={
        <Link to="/professionals" data-testid="featured-view-all"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#E6C878] hover:text-white">View All Professionals <ArrowRight className="h-4 w-4" /></Link>
      } />
  );
}

export default FeaturedProsCarousel;
